// src/layouts/legal/Terms.js
import React from "react";
import { Container, Typography, Link } from "@mui/material";

export default function Terms() {
  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <Typography variant="h3" gutterBottom>
        Terms of Service
      </Typography>
      <Typography paragraph>
        These Terms of Service (“Terms”) govern your use of QuickHub (“Service”). By using the
        Service, you agree to these Terms.
      </Typography>

      <Typography variant="h5" gutterBottom>
        1. Service & Account
      </Typography>
      <Typography paragraph>
        You must provide accurate information and keep your credentials secure. You’re responsible
        for activities under your account.
      </Typography>

      <Typography variant="h5" gutterBottom>
        2. Data & Integrations
      </Typography>
      <Typography paragraph>
        The Service may connect to third-party systems (e.g., Intuit QuickBooks). By enabling
        integrations, you authorize access to data required to operate features.
      </Typography>

      <Typography variant="h5" gutterBottom>
        3. Liability
      </Typography>
      <Typography paragraph>
        The Service is provided “as is” without warranties. To the maximum extent permitted by law,
        we are not liable for indirect or consequential damages.
      </Typography>

      <Typography variant="h5" gutterBottom>
        4. Termination
      </Typography>
      <Typography paragraph>
        We may suspend or terminate access if terms are breached or for security reasons. You may
        stop using the Service at any time.
      </Typography>

      <Typography variant="h5" gutterBottom>
        5. Contact
      </Typography>
      <Typography paragraph>
        For questions, contact:{" "}
        <Link href="mailto:support@budgycraft.com">support@budgycraft.com</Link>.
      </Typography>
    </Container>
  );
}
